export enum SocialMediaChannelsEnum {
  FACEBOOK = 'FACEBOOK',
  TWITTER = 'TWITTER',
  LINE = 'LINE',
}
